import AddressesFromClientA from "./DynamicComponet/AddressesFromClientA";

export type AddressesFromClientProps = {
  clientErpId?: string | null;

};

export default function AddressesFromClient({ clientErpId }: AddressesFromClientProps) {
  if (!clientErpId) return <p>Cliente não selecionado.</p>;

  return (
    <div>

      <AddressesFromClientA clientErpId={clientErpId} />
    </div>
  );
}
